import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function HeroSection() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative h-[50vh] bg-[#0f0f0f] overflow-hidden text-light flex items-center justify-center">
      {/* Zdjęcie w tle z efektem parallax */}
      <img
        src="/images/banner.png"
        alt="Hero Background"
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        style={{ transform: `translateY(${offsetY * 0.3}px)` }}
      />

      {/* Overlay ciemny */}
      <div className="absolute inset-0 bg-black/50 z-10"></div>

      {/* Treść hero z animacją */}
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative z-20 text-center px-4"
      >
        <h1
          className="text-8xl font-heading"
          style={{ fontFamily: "Bhorgcust" }}
        >
          Restauracja Magiczna
        </h1>
        <p className="text-md text-white/80 mt-2">
          Wyjątkowe chwile, wyjątkowy smak
        </p>
      </motion.div>
    </section>
  );
}
